import React from 'react'
import './css/About.css'
import profile_photo from './images/profile_photo.jpg'
import new_resume from './pdf/new_resume.pdf'

function About() {
  return (
    <div>

    <section id="about">
        <div className="container">
            <h2 className="section-heading" data-outline="about">About</h2>
            <div className="wrapper">
                <div className="left">
                    <div className="card">
                        <div className="img">
                            <img src={profile_photo} alt="" />
                        </div>
                        <p className="card-desc">I'm a web developer based in India. I love the
                            Web platform
                            and I need to improve it for
                            everybody. What's more, I believe myself to be totally honored that I will assemble it
                            professionally.</p>
                        <h3 className="card-name">Subhadip Mandal</h3>
                        <p className="card-sub-title">Student of Techno International Newtown</p>
                    </div>
                </div>
                <div className="right">
                    <p className="subheading">Hi! This is Subhadip</p>
                    <h2 className="slogan">Student</h2>
                    <p className="right-text">
                        I am from West Bengal, India.
                        Currently i'm pursuing Bachelor of Computer Application in Techno International Newtown.
                        <br/>
                        Apart from coding, some other activities that I love to do!    
                    </p>
                    <ul>
                        <li>Playing Games like Football and Vollyball.</li>
                        <li>Reading Story Books.</li>
                        <li>Watching Movies.</li>
                        <li>Travelling.</li>
                    </ul>
                    <div className="buttons">
                        <a href={new_resume} className="primary-btn" download="">Download Resume</a>
                        <a href="contact" className="primary-btn outline">Hire Me</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    </div>
  )
}

export default About